import { AlarmActivationSummary } from '@repo/sdk/models/components';

import { UseWebsocketQueryOptions } from '@/hooks/query-hooks/websockets';
import { GaiaQueryWithAgentId, QueryToast } from '@/queries/types';

export const alarmActivationsSummaryQuery = ({
  agentId,
}: GaiaQueryWithAgentId): UseWebsocketQueryOptions<AlarmActivationSummary | null> => {
  return {
    enabled: !!agentId,
    queryKey: [agentId, 'alarmActivationsSummary'],
    staleTime: Infinity,
    meta: {
      toast: {
        severity: 'off',
      } as QueryToast,
    },
    webSocketUrl: `/bff/v1/agents/${agentId}/alarms-stream`,
  };
};
